import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'language-settings.unsaved-changes-modal.title',
		defaultMessage: 'Unsaved changes',
		description: 'Title for Unsaved changes Modal',
	},
	body: {
		id: 'language-settings.unsaved-changes-modal.body',
		defaultMessage: 'You have unsaved changes. Save or discard your changes to continue.',
		description: 'Message for Unsaved Changes Modal',
	},
	saveButton: {
		id: 'language-settings.unsaved-changes-modal.save-button',
		defaultMessage: 'Save',
		description: 'Save Button',
	},
	discardButton: {
		id: 'language-settings.unsaved-changes-modal.discard-button',
		defaultMessage: 'Discard',
		description: 'Discard Button',
	},
	cancelButton: {
		id: 'language-settings.unsaved-changes-modal.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Cancel Button',
	},
	translationsSaveSuccess: {
		id: 'language-settings.unsaved-changes-modal.translations-save-success',
		defaultMessage: 'Translations saved successfully',
		description: 'Success message when translations are saved successfully',
	},
	disabledErrorMessage: {
		id: 'language-settings.unsaved-changes-modal.disabled-error-message',
		defaultMessage: "Your current plan doesn't allow to edit the notification templates.",
		description: 'Error message shown when editing is disabled for the current plan',
	},
	genericErrorMessage: {
		id: 'language-settings.unsaved-changes-modal.generic-error-message',
		defaultMessage:
			'Something has gone wrong with your request. If symptoms persist contact your System Administrator.',
		description: 'Error message to be shown if save fails',
	},
});
